import { useState } from "react";
import Mandala from "../../images/Banner/Mandala.png";
import WaxSealStamp from "../../images/Banner/sealStampLight.png";
import { getBrideGroomNameFromURL } from "../../utils/string";

const heartSvg = (
  <svg viewBox="0 0 32 29" width="25" height="25">
    <path
      d="M23.6,0c-3.4,0-6.4,2-7.6,5.1C14.8,2,11.8,0,8.4,0
           C3.8,0,0,3.8,0,8.4c0,9.3,16,20.6,16,20.6s16-11.3,16-20.6
           C32,3.8,28.2,0,23.6,0z"
      fill="currentColor"
    />
  </svg>
);

export const RevealFlash = ({ active }) => {
  return (
    <div className={`reveal-flash ${active ? "active" : ""}`}>
      <div className="glow"></div>
    </div>
  );
};

const Envelope = ({ loading = true, onOpenInvite, active = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hideWrapper, setHideWrapper] = useState(false);
  const { brideName, groomName } = getBrideGroomNameFromURL();

  const openEnvelope = () => {
    if (isOpen) return;
    setIsOpen(true);
    setTimeout(() => {
      setHideWrapper(true);
      onOpenInvite();
    }, 1000);
  };

  return (
    <div className={`wrapper ${hideWrapper ? "hide" : ""}`}>
      <div className={`envelope ${isOpen ? "open" : ""}`}>
        <div className="base" />
        <div class="mandala mandala-bottom">
          <img src={Mandala} alt="mandala" />
        </div>

        <button className={`waxSealBtn`} onClick={openEnvelope}>
          <img
            className={`${!loading ? "buzzAnime" : ""}`}
            src={WaxSealStamp}
            alt="Open Invitation"
          />
          <p className="sealLabel">Tap to Reveal</p>
        </button>

        <div className="flap"></div>

        <div className="names">
          <p className="tagline">A Special Invite For You</p>

          <h1 className="couple-names">
            {brideName} <span style={{ marginTop: "-5px" }}>{heartSvg}</span>{" "}
            {groomName}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default Envelope;
